import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CererePriorityAddPayload, CererePriorityUpdatePayload } from './cerere-priority.interface';
import { catchError, map, tap, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CererePriorityService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getCererePrioritiesUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.getCererePriorities;
    private getCererePriorityDT = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.getCererePrioritiesDT;
    private storeCererePriorityURL = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.storeCererePriority;
    private updateStoreCererePriority = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.putCererePriority;
    private deleteStoreCererePriority = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.deleteCererePriority;
    private getCererePrioritiesActive = this.basePath + environment.interop.urbanism.nomenclatoare.cererePriority.getCererePrioritiesActive;
    private getCererePrioritiesPublic = this.basePath + environment.interop.urbanism.nomenclatoare.cererePriority.getCererePrioritiesActivePublic;

    private changeStatusActiveUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.changeStatusCererePriorityActive;

    private changeStatusPublicUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.changeStatusCererePriorityPublic;

    private clearCacheUrl = this.basePath + environment.interop.dgitl.nomenclatoare.cererePriority.clearCache;

    constructor(private http: HttpClient) { }

    getCererePrioritiesDT() {
        return this.http.post(this.getCererePriorityDT, this.httpOptions);
    }

    clearCache() {
        return this.http.get(this.clearCacheUrl, this.httpOptions);
    }

    addCererePriority(cererePriority: CererePriorityAddPayload) {
        return this.http.post(this.storeCererePriorityURL, cererePriority, this.httpOptions);
    }

    updateCererePriority(cererePriority: CererePriorityUpdatePayload) {
        return this.http.put(this.updateStoreCererePriority, cererePriority, this.httpOptions);
    }

    deleteCererePriority(cererePriorityId: number) {
        return this.http.delete(this.deleteStoreCererePriority + cererePriorityId);
    }

    getActiveCererePriorities() {
        return this.http.get(this.getCererePrioritiesActive, this.httpOptions);
    }

    getPublicCererePriorities() {
        return this.http.get(this.getCererePrioritiesPublic, this.httpOptions);
    }

    getCererePriorities() {
        return this.http
            .get<{ errors: boolean; data: any; status_code: number }>(
                this.getCererePrioritiesUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item: any) => ({
                        id: item.id_cerere_priority,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get request priorities:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${this.token}`
            })
        };
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }
}
